import apiClient from 'api';
import _ from 'lodash';
import { filterForAllowedProperties, formatControlTypes } from 'utils/format';
import { fetchAllFromMonitorServer } from 'api/common';

const monitorApiBaseUrl = window.env.REACT_APP_MONITOR_API_PATH;
const northgateApiBaseUrl = window.env.REACT_APP_NORTHGATE_API_PATH;

export const allowedIndeNodesProperties = [
  'primacy',
  'indeNodeId',
  'description',
  'pollRate',
  'localNode'
];

export const fetchAllIndeNodes = async (queryParams = {}) => {
  const indeNodes = await fetchAllFromMonitorServer(
    'indenode',
    ['devId', 'id', 'desc', 'start', 'limit'],
    queryParams
  );
  return indeNodes.map(indeNode =>
    filterForAllowedProperties(indeNode, allowedIndeNodesProperties)
  );
};

export const fetchIndeNodeById = async id => {
  const [indeNode] = await fetchAllIndeNodes({ id });
  return indeNode;
};

export const remove = async indeNodeId => {
  return await apiClient.delete(northgateApiBaseUrl, `/indenode/${indeNodeId}`);
};

export const edit = async (indeNodeId, reqBody) => {
  return await apiClient.put(
    northgateApiBaseUrl,
    `/indenode/${indeNodeId}`,
    reqBody
  );
};

export const create = async reqBody => {
  const filteredPayload = _.omitBy(
    reqBody,
    value => value === null || value === ''
  );
  return await apiClient.post(
    northgateApiBaseUrl,
    `/indenode`,
    filteredPayload
  );
};

export const fetchIndeNodeDefaultControl = async indeNodeId => {
  const defaultControl = await apiClient.get(
    monitorApiBaseUrl,
    `/indenode/${indeNodeId}/default`
  );
  return formatControlTypes(defaultControl);
};

export const updateDefaultControl = async (nodeId, control) => {
  const filteredPayload = _.omitBy(
    control,
    value => value === null || value === '' || _.isNaN(value)
  );
  await apiClient.put(
    northgateApiBaseUrl,
    `/indenode/${nodeId}/default`,
    filteredPayload
  );

  return formatControlTypes(filteredPayload);
};
